export default __webpack_public_path__ + "public/images/report-demo-2.svg";